export const APPLY_PROMO_CODE_LINK_CLICK = 'Apply promo code link click'
